import { IBetOnPokerGameState, IBetOnPokerSelectData } from './interfaces';

export const betOnPokerSelectors = {
    selectData: (state: IBetOnPokerGameState): IBetOnPokerSelectData => ({
        ...state.data,
        handsBettingOptions: state.oddGroups[0].ids.map((id) => state.data.bettingOptions[id]),
        combinationBettingOptionsGroup: {
            id: state.oddGroups[1].id,
            options: state.oddGroups[1].ids.map((id) => state.data.bettingOptions[id]),
        },
        oddsGroups: state.oddGroups,
    }),
};
